import { RelinkSetup } from "./RelinkSetup";
import { PlatformAdminApp } from "./platform/PlatformAdminApp";

// 保留上游底座，移动端私人档案不接入管理后台的数据域。
const App = () =>
  import.meta.env.VITE_SUPABASE_URL &&
  import.meta.env.VITE_SB_PUBLISHABLE_KEY ? (
    <PlatformAdminApp />
  ) : (
    <RelinkSetup />
  );

export default App;
